<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";

export default {
  name: "Inventory valuation",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      total_values: {
        inventory_value: 0.0,
        retail_value: 0.0,
        potential_profit: 0.0,
        margin: 0.0
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      currentSorting: "",
      decimal_separator: ".",
      precision: 0,
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.$api
        .getAPI({
          _action:
            "/inventory_count/inventory_valuation/" +
            this.itemsPerPage +
            "/" +
            page,
          _body: this.filterObj
        })
        .then(res => {
          this.total_values = res;
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_inventory_valuation_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/inventory_count/export_inventory_valuation/" +
          localStorage.getItem("client_id") +
          queryParam
          , _fileName: 'inventory_valuation.csv'})
    }
  },
  mounted() {
    this.getStoreList();
    this.getList(1);
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-lg-12 text-right">
          <div
            class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
            style="width: 160px;">
            <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_stores}}</option>
              <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-3 col-xlg-3">
          <div class="card card-hover">
            <div class="box bg-cyan text-center">
              <p class="text-white font-18 mb-0">{{$lang.messages.total_inventory_value}}</p>
              <h4 class="text-white h1 f-bold font-30">
                <vue-numeric
                  v-bind:precision="precision"
                  :separator="decimal_separator"
                  :value="total_values.inventory_value"
                  :read-only="true"/>
              </h4>
            </div>
          </div>
        </div>
        <!-- Column -->
        <div class="col-md-6 col-lg-3 col-xlg-3">
          <div class="card card-hover">
            <div class="box bg-success text-center">
              <p class="text-white font-18 mb-0">{{$lang.messages.total_retail_value}}</p>
              <h4 class="text-white h1 f-bold font-30">
                <vue-numeric
                  v-bind:precision="precision"
                  :separator="decimal_separator"
                  :value="total_values.retail_value"
                  :read-only="true"
                />
              </h4>
            </div>
          </div>
        </div>
        <!-- Column -->
        <div class="col-md-6 col-lg-3 col-xlg-3">
          <div class="card card-hover">
            <div class="box bg-warning text-center">
              <p class="text-white font-18 mb-0">{{$lang.messages.potential_profit}}</p>
              <h4 class="text-white h1 f-bold font-30">
                <vue-numeric
                  v-bind:precision="precision"
                  :separator="decimal_separator"
                  :value="total_values.potential_profit"
                  :read-only="true"
                />
              </h4>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 col-xlg-3">
          <div class="card card-hover">
            <div class="box bg-info text-center">
              <p class="text-white font-18 mb-0">{{$lang.messages.margin}}</p>
              <h4 class="text-white h1 f-bold font-30">
                <vue-numeric
                  v-bind:precision="precision"
                  :separator="decimal_separator"
                  :value="total_values.margin"
                  :read-only="true"
                /> %</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card rounded-5">
            <div class="bg-white mt-3">
              <div class="pink-tape py-1">
                <div class="row">
                  <div class="col-md-8 col-5 align-self-center pt-1">
                    <a
                      href="javascript:void(0)"
                      class="font-22 mb-0 text-regular text-hover-primary"
                      @click="getExport()"
                    >
                      {{$lang.messages.export}}
                      <i class="mdi mdi-download align-text-top"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body table-responsive">
              <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th scope="col">Sr.no</th>
                    <th scope="col">{{$lang.messages.item}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.in_stock}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.cost}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.inventory_value}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.retail_value}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.potential_profit}}</th>
                    <th scope="col" class="text-center">{{$lang.messages.margin}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(valuation,i) in list">
                    <tr :key="valuation.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td class="f-semi-bold">{{valuation.name ? valuation.name : "-"}}</td>
                      <td class="text-center">{{valuation.in_stock ? valuation.in_stock : "-"}}</td>
                      <td class="text-center">
                        <vue-numeric
                          v-if="valuation.cost"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="valuation.cost"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td
                        class="text-center"
                      >
                        <vue-numeric
                          v-if="valuation.inventory_value"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="valuation.inventory_value"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      <td
                        class="text-center"
                      >
                        <vue-numeric
                          v-if="valuation.retail_value"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="valuation.retail_value"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td
                        class="text-center"
                      >
                        <vue-numeric
                          v-if="valuation.potential_profit"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="valuation.potential_profit"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td class="text-center">{{valuation.margin ? valuation.margin : "-"}}%</td>
                    </tr>

                    <tr
                      class="bg-white border-top-0 border-bottom-0"
                      v-for="item in valuation.item_variant_combination"
                      :key="item.name"
                    >
                      <td class="text-center font-14 border-0"></td>
                      <td class="font-14 border-0">{{item.name ? item.name : '-' }}</td>
                      <td
                        class="text-center font-14 border-0"
                      >{{item.in_stock ? item.in_stock : '-' }}</td>
                      <td class="text-center font-14 border-0">
                        <vue-numeric
                          v-if="item.cost"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="item.cost"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td
                        class="text-center font-14 border-0"
                      >
                        <vue-numeric
                          v-if="item.inventory_value"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="item.inventory_value"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td
                        class="text-center font-14 border-0"
                      >
                        <vue-numeric
                          v-if="item.retail_value"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="item.retail_value"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td
                        class="text-center font-14 border-0"
                      >
                        <vue-numeric
                          v-if="item.potential_profit"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="item.potential_profit"
                          :read-only="true"
                        />
                        <span
                          v-else
                        >-</span>
                      </td>
                      <td class="text-center font-14 border-0">{{item.margin ? item.margin : '-' }}%</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <ErrorComponent @retry="retry()" ref="errorComonent" />
            </div>
          </div>

          <div class="page-bottom-pagination text-right">
            <Pagination
              @page-change="pageChange"
              @items-per-page-change="itemsPerPageChange()"
              ref="listPagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
